import Multimedia from "@sharedComponents/multimedia";

import sampleImage from "@images/blank-image.png";

import style from "./main.module.scss";

const ShadowCard = ({
  customClass = "",
  customeTitle = "",
  customeImageBlock = "",
  customeBtnBlock = "",
  customeBrandTitle = "",
  customFooterClassName = "",
  width = "1200",
  height = "380",
}) => {
  return (
    <div className={`${style.productTile} ${style[customClass]} ${customClass}`}>
      <div className={`${style.productImageBlock} ${style.shadowBg} ${customeImageBlock}`}>
        <Multimedia type="image" src={sampleImage} width={width} height={height} />
      </div>
      <div className={`${style.tileFooter} ${customFooterClassName}`}>
        <div className={style.detailBar}>
          <span className={`${style.brandTitle} ${style.shadowBg} ${customeBrandTitle}`}></span>
          <span className={`${style.btnBlcok} ${style.shadowBg} ${customeBtnBlock}`} />
        </div>

        <div className={`${style.productTitle} ${style.shadowBg} ${customeTitle}`}></div>

        <div className={`${style.productPoint} ${style.shadowBg}`}></div>
      </div>
    </div>
  );
};
export default ShadowCard;
